module.exports = __webpack_public_path__ + "static/media/ic-refresh-fill.1f4fdbd2.svg";